import React from 'react'
import styled from 'styled-components'
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'

import { Textarea } from '../form/Textarea'

import FieldWrapper from './Field'

const MaxLength = styled.span<{ error?: boolean }>`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xxs']?.['font-size']?.value};
  color: ${({ theme, error }) =>
    error
      ? theme?.['-ds-error-300']?.value
      : theme?.['-ds-neutral-500']?.value};
`

type Props = {
  name: string
  label?: React.ReactNode
  placeholder?: string

  /**
   * Options to pass to the react-hook-form register function
   */
  validationRules?: RegisterOptions
  formatValue?: (value: string) => string
  rounded?: boolean
  showLength?: boolean
  noResize?: boolean
}

const TextareaField = ({
  name,
  label,
  placeholder = '',
  validationRules,
  formatValue,
  rounded = true,
  showLength,
  noResize,
}: Props) => {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      rules={validationRules}
      render={({ field: { onChange, ...field }, fieldState: { error } }) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          if (formatValue != null) {
            const nextValue = formatValue(e.target.value)
            return onChange(nextValue)
          }

          return onChange(e.target.value)
        }

        const messageLength = field?.value?.length || 0

        const maxLength =
          // @ts-ignore -- types don't reflect that maxLength could be a number or an object of shape { value: number, message: string }
          validationRules?.maxLength?.value || validationRules?.maxLength

        return (
          <>
            <FieldWrapper
              name={name}
              label={label}
              annotations={
                showLength && (
                  <MaxLength error={error?.type === 'maxLength'}>
                    {messageLength}
                    {maxLength && <>/{maxLength}</>}
                  </MaxLength>
                )
              }
            >
              <Textarea
                {...field}
                onChange={handleChange}
                id={name}
                name={name}
                placeholder={placeholder}
                error={!!error}
                rounded={rounded}
                noResize={noResize}
              />
            </FieldWrapper>
          </>
        )
      }}
    />
  )
}

export default TextareaField
